// extracted by mini-css-extract-plugin
export default {"wrap":"oH-z","subtitle":"pH-z","contentWrap":"qH-z","imgWrap":"rH-z","heading":"sH-z","copy":"tH-z"};